/**
 * Verkrijg taal op basis van browserinstellingen.
 * Extra check op `window` i.v.m. SSR in experience editor!
 * @returns {String}
 */
export const getBrowserLang = () => {
    let lang = 'nl-NL';

    if (typeof window !== 'undefined') {
        if (navigator?.languages) {
            lang = navigator.languages[0];
        } else if (navigator.language) {
            lang = navigator.language;
        }
    }

    return lang;
};

/**
 * Verkrijg taal op basis van sitecore JSS context
 * Gebruik browser taal als fallback
 * @param {Object} $jss
 * @returns {String}
 */
export const getLocale = $jss => {
    const browserLang = getBrowserLang();
    const jssLang = $jss?.sitecoreContext()?.language;

    return jssLang || browserLang;
};

/**
 * Geeft eerste deel van locale terug (taalcode)
 * Op basis van JSS context
 * @param {Object} $jss
 * @returns {String}
 */
export const getLocaleCode = $jss => {
    const locale = getLocale($jss);

    return locale.split('-')[0];
};

/**
 * Get local directly from language arg
 * For usage with Vue 3 and 'useScContext' composable
 * Use native browser language as fallback
 * @param {string|undefined} lang
 */
export const getLocalFromLang = lang => lang || getBrowserLang();

/**
 * Get local code directly from language arg
 * For usage with Vue 3 and 'useScContext' composable
 * Use native browser language as fallback
 * @param {string|undefined} lang
 */
export const getLocalCodeFromLang = lang => getLocalFromLang(lang).split('-')[0];
